<template>
  <div class="container">
    <el-tabs v-model="activeName" @tab-click="handleClick" type="card">
      <el-tab-pane label="大图管理" name="bigImageAdmin">
        <!--<el-checkbox v-model="filters.onlyUnchecked" >只看已纠错</el-checkbox>-->
        <labelTaskAdmin
          @preMark="premrk"
          @cancelCheck="cancelCheck"
          @viewDetail="viewDetail"
          :labelTaskList="label_task_list"
        ></labelTaskAdmin>
      </el-tab-pane>
      <el-tab-pane label="模型管理" name="modelUpload">
        <template>
          <el-row :gutter="10">
            <!--<el-col :span="6">10</el-col>-->
            <el-button
              type="primary"
              size="mini"
              @click="uploadDialogShow = true"
              >上传模型</el-button
            >
            <el-button type="primary" size="mini" @click="getAllRegionModel"
              >刷新</el-button
            >
            <el-dialog
              title="请输入模型信息"
              :visible.sync="uploadDialogShow"
              width="50%"
            >
              <el-form
                ref="uploadForm"
                :model="modelForm"
                label-width="80px"
                :rules="modelRules"
              >
                <el-form-item label="模型选择" prop="model_url">
                  <el-upload
                    ref="modelUpload"
                    class="upload-demo"
                    action
                    :limit="1"
                    :before-upload="beforeUpload"
                    :http-request="modelUpload"
                  >
                    <el-button size="small" type="primary"
                      >请选择要上传的模型</el-button
                    >
                  </el-upload>
                </el-form-item>
                <el-form-item label="模型名称" prop="model_name">
                  <el-input
                    v-model="modelForm.model_name"
                    placeholder="请输入模型名称"
                  ></el-input>
                </el-form-item>
                <el-form-item label="模型描述" prop="model_desc">
                  <el-input
                    v-model="modelForm.model_desc"
                    placeholder="请输入模型描述"
                  ></el-input>
                </el-form-item>
              </el-form>
              <span slot="footer" class="dialog-footer">
                <el-button @click="cancelUpload">取 消</el-button>
                <el-button type="primary" @click="confirmUpload"
                  >确 定</el-button
                >
              </span>
            </el-dialog>
          </el-row>
          <el-table :data="region_models_list" style="width: 100%">
            <el-table-column
              header-align="center"
              align="center"
              prop="model_name"
              label="名称"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="model_desc"
              label="描述"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              label="添加时间"
            >
              <template slot-scope="scope">
                {{ scope.row.create_ts | tsToDate }}
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              label="是否标准"
            >
              <template slot-scope="scope">
                <el-tag type="success" v-if="scope.row.is_standard === true"
                  >标准</el-tag
                >
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              label="版本号"
            >
              <template slot-scope="scope">{{
                scope.row.version || "无"
              }}</template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              label="是否发布"
            >
              <template slot-scope="scope">
                <el-tag type="success" v-if="scope.row.is_published === '1'"
                  >已发布</el-tag>
                <el-tag type="danger" v-else>未发布</el-tag>
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              label="发布时间"
            >
              <template
                slot-scope="scope"
                v-if="scope.row.is_published === '1'"
              >
                {{ scope.row.publish_ts | tsToDate }}
              </template>
              <template v-else slot-scope="scope">
                -
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              label="操作"
              :width="200"
            >
              <template slot-scope="scope">
                <!--<el-button type="text" @click="downLoad(scope.row)">下载</el-button>-->
                <el-button type="text" @click="regionModelCheck(scope.row)"
                  >检测</el-button
                >
                <el-button type="text" @click="setStandard(scope.row)"
                  >设为标准</el-button
                >
                <!-- <el-button type="text" @click="emitPublishDialog(scope.row)"
                  >发布</el-button
                > -->
              </template>
            </el-table-column>
          </el-table>
        </template>
      </el-tab-pane>
      <el-tab-pane label="任务列表" name="taskList">
        <regionTask @setActiveTab="setActiveTab" ref="regionTask"></regionTask>
      </el-tab-pane>
      <el-tab-pane label="图框纠正" name="regionFix" :disabled="true">
        <regionFixWrapper
          v-if="activeName === 'regionFix'"
          @setActiveTab="setActiveTab"
        ></regionFixWrapper>
      </el-tab-pane>
      <el-tab-pane label="检测结果" name="regionCheckResult" :disabled="true">
        <regionCheckResult
          v-if="activeName === 'regionCheckResult'"
        ></regionCheckResult>
      </el-tab-pane>
    </el-tabs>
    <el-dialog
      title="请选择用于检测的大图"
      :visible.sync="bigImageBatchShow"
      width="700"
    >
      <el-input v-model="searchBox" placeholder="快速搜索" size="mini"></el-input>
      <vv-table
        :config="labelTaskTableConfig"
        :data="label_task_list_filter"
        :minWidth="600"
        :height="450"
      >
        <template slot-scope="scope" slot="event_slot">
          <el-button
            type="text"
            size="mini"
            :disabled="!scope.row.is_check || !scope.row.is_mark"
            @click="selectToCheck(scope.row)"
            >选择</el-button
          >
          <!--<el-button type="text" size="mini">下载</el-button>-->
        </template>
        <template slot-scope="scope" slot="canteen_slot">{{
          findCanteen(scope.row)
        }}</template>
        <template slot-scope="scope" slot="date_slot">
          {{ scope.row.label_task_day_ts | tsToDate }}
        </template>
        <template slot-scope="scope" slot="count_slot">
          {{ scope.row.count || 0 }}
        </template>
        <template slot-scope="scope" slot="state_slot">
          <el-tag v-if="scope.row.is_mark" type="success" size="mini"
            >已标注</el-tag
          >
          <el-tag v-else type="danger" size="mini">未标注</el-tag>
          <el-tag v-if="scope.row.is_check" type="success" size="mini"
            >已纠错</el-tag
          >
          <el-tag v-else type="danger" size="mini">未纠错</el-tag>
        </template>
      </vv-table>
      <!--<el-table :data="label_task_list" style="width: 100%" height="60vh">-->
      <!--<el-table-column header-align="center" align="center" label="餐厅">-->
      <!--<template slot-scope="scope">{{ findCanteen(scope.row) }}</template>-->
      <!--</el-table-column>-->
      <!--<el-table-column header-align="center" align="center" label="创建时间">-->
      <!--<template slot-scope="scope">-->
      <!--{{ scope.row.create_ts | tsToDate }}-->
      <!--</template>-->
      <!--</el-table-column>-->
      <!--<el-table-column header-align="center" align="center" label="创建时间">-->
      <!--<template slot-scope="scope">-->
      <!--{{ scope.row.create_ts | tsToDate }}-->
      <!--</template>-->
      <!--</el-table-column>-->
      <!--<el-table-column header-align="center" align="center" label="总数">-->
      <!--<template slot-scope="scope">{{ scope.row.count || 0 }}</template>-->
      <!--</el-table-column>-->
      <!--<el-table-column header-align="center" align="center" label="是否预标">-->
      <!--<template slot-scope="scope">-->
      <!--<el-tag v-if="scope.row.is_mark" type="success" size="mini"-->
      <!--&gt;已标注</el-tag-->
      <!--&gt;-->
      <!--<el-tag v-else type="danger" size="mini">未标注</el-tag>-->
      <!--<el-tag v-if="scope.row.is_check" type="success" size="mini"-->
      <!--&gt;已纠错</el-tag-->
      <!--&gt;-->
      <!--<el-tag v-else type="danger" size="mini">未纠错</el-tag>-->
      <!--</template>-->
      <!--</el-table-column>-->
      <!--<el-table-column header-align="center" align="center" label="操作">-->
      <!--<template slot-scope="scope">-->
      <!--<el-button-->
      <!--type="text"-->
      <!--size="mini"-->
      <!--:disabled="!scope.row.is_check || !scope.row.is_mark"-->
      <!--@click="selectToCheck(scope.row)"-->
      <!--&gt;选择</el-button-->
      <!--&gt;-->
      <!--&lt;!&ndash;<el-button type="text" size="mini">下载</el-button>&ndash;&gt;-->
      <!--</template>-->
      <!--</el-table-column>-->
      <!--</el-table>-->
    </el-dialog>
    <el-dialog
      title="请选择调整下图中的矩形框已制定采集区域"
      :visible.sync="detectedReionDialog"
      width="50%"
      align="center"
    >
      <detectedRegion
        v-if="detectedReionDialog"
        :image="detected_image"
        @detectedRegion="onDetectedRegion"
      ></detectedRegion>
    </el-dialog>
    <el-dialog
      title="请选择要发布的餐厅"
      :visible.sync="publishDialogShow"
      width="50%"
    >
      <el-input
        v-model="publishModelForm.search"
        placeholder="快速搜索"
      ></el-input>
      <el-button type="text" @click="selectAll" class="danger-text" size="mini"
        >全选</el-button
      >
      <el-button type="text" @click="cancelAll" class="danger-text" size="mini"
        >取消</el-button
      >
      <vvTable
        :config="tableConfig"
        :data="canteenListFilter"
        :minWidth="100"
        :height="500"
      >
        <template slot-scope="scope" slot="event_slot">
          <el-button
            type="text"
            v-if="
              publishModelForm.canteen_id_list.indexOf(scope.row.canteen_id) ===
                -1
            "
            @click="handleSelect(scope.row.canteen_id)"
            size="mini"
            >选择
          </el-button>
          <el-button
            type="text"
            v-else
            class="danger-text"
            @click="cancelSelect"
            size="mini"
            >取消选择</el-button
          >
        </template>
      </vvTable>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelPublishModel">取 消</el-button>
        <el-button type="primary" @click="publishModel">发 布</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {mapActions, mapGetters, mapMutations} from 'vuex';
import regionFixWrapper from './regionFixWrapper';
import detectedRegion from './detectedRegion';
import regionTask from './regionTask';
import pinyinMatch from 'pinyin-match';
import regionCheckResult from './regionCheckResult';
import vvTable from 'vue-virtual-table';
import labelTaskAdmin from './labelTaskAdmin';
import {
  apiGetAllRegionLabelTask,
  apiGetAllRegionModels,
  apiGetDetailByLabelTaskId,
  apiRegionCheck,
  apiRegionImageRandomGetByTaskId,
  apiRegionLabelCancelCheck,
  apiRegionModelPreMark,
  apiRegionModelPublish,
  apiSetStandard,
  apiUploadRegionModel,
  apiGetAllCategoryList
} from '@/api';
import aliOSSUpload from '@/lib/aliOSSUpload';
import md5 from 'js-md5';
import moment from 'moment';

export default {
  components: {
    vvTable,
    labelTaskAdmin,
    regionFixWrapper,
    detectedRegion,
    regionTask,
    regionCheckResult
  },
  data() {
    return {
      searchBox: '',
      valueKey: "",
      selectedCanteen: [],
      tableConfig: [
        { prop: "_action", name: "操作", actionName: "event_slot", width: 100 },
        { prop: "eatery_name", name: "食堂名称", width: 100 },
        { prop: "canteen_name", name: "餐厅名称", width: 100 }
      ],
      labelTaskTableConfig: [
        { prop: "_action", name: "操作", actionName: "event_slot", width: 50 },
        { prop: "_action", name: "餐厅", actionName: "canteen_slot", width: 150 },
        {
          prop: "_action",
          name: "批次时间",
          actionName: "date_slot",
          width: 150
        },
        {
          prop: "_action",
          name: "图片总数",
          actionName: "count_slot",
          width: 100
        },
        { prop: "_action", name: "状态", actionName: "state_slot", width: 150 }
      ],
      filters: {
        onlyUnchecked: false,
        onlyChecked: false
      },
      publishDialogShow: false,
      publishModelForm: {
        model_uuid: "",
        canteen_id_list: [], // -1: '全部', []: 餐厅idlist
        search: ""
      },
      zipTaskShow: false,
      label_task_ids: [],
      allZipTask: [],
      preMarkRegionModel: "84fffc22505811e98e8000163e09e229",
      modelTableShow: false,
      regionCheckForm: {
        detected_region: {},
        label_task_id: "",
        region_model_id: ""
      },
      detected_image: {},
      // 画框弹窗
      detectedReionDialog: false,
      // 完成之后需要清空
      selectRegionModel: {},
      bigImageBatchShow: false,
      label_task_list: [],
      region_models_list: [],
      modelRules: {
        model_name: [
          { required: true, message: "请输入模型名称", trigger: "blur" }
        ],
        model_url: [{ required: true, message: "请上传模型" }]
      },
      uploadDialogShow: false,
      activeName: "bigImageAdmin",
      modelForm: {
        model_name: "",
        model_desc: "",
        model_md5: "",
        model_url: "",
        manual_upload: true
      }
    };
  },

  mounted() {
    this.$store.commit("setSubTitle", "识别框矫正");
    this.setAllCanteenList();
    this.getAllRegionLabelTask();
    this.getAllRegionModel();
    this.getCategoryList();
  },
  computed: {
    ...mapGetters(["allCanteenList", "standardRegionModel", "userinfo"]),
    username() {
      return this.userinfo().username;
    },
    canteenListFilter() {
      let list = this.allCanteenList;
      let searchText = this.publishModelForm.search;
      return list.filter(a => {
        let res = pinyinMatch.match(
          a.canteen_name + "," + a.eatery_name,
          searchText
        );
        return res.length > 0;
      });
    },
    label_task_list_filter() {
      let list = this.label_task_list;
      list = this.$_.sortBy(list, "label_task_day_ts", "desc");
      const searchText = this.searchBox;
      if (searchText) {
        list = list.filter(a => {
          const canteen = this.findCanteen(a);
          let res = pinyinMatch.match(canteen, searchText);
          // console.log(res);
          return res.length > 0;
        });
      }
      return list;
    }
  },
  filters: {
    tsToDate(ts) {
      if (ts === 0) {
        return "-";
      } else {
        return moment(ts * 1000).format("YYYY-MM-DD HH:mm");
      }
    }
  },
  methods: {
    ...mapMutations(["setStandardRegionModel", "emitLoading", "removeLoading"]),
    ...mapActions(["setAllCanteenList", "setPremarkData"]),
    async getCategoryList () {
      try {
        const res = await apiGetAllCategoryList();
        console.log(res);
        this.$store.commit('SET_ALL_CATEGORY_LIST', res);
        console.log(res);
      } catch (e) {
        console.log(e);
        this.$message.error('图框大类查询失败' + e.message);
      }
    },
    selectAll() {
      this.publishModelForm.canteen_id_list = [];
      this.$set(
        this.publishModelForm,
        "canteen_id_list",
        this.canteenListFilter.map(a => a.canteen_id)
      );
    },
    cancelAll() {
      this.publishModelForm.canteen_id_list = [];
    },
    handleSelect(canteen_id) {
      // this.publishDialogShow.canteen_id_list = [];
      this.publishModelForm.canteen_id_list.push(canteen_id);
    },
    cancelSelect(canteen_id) {
      let idx = this.$_.findIndex(
        this.publishDialogShow.canteen_id_list,
        a => a === canteen_id
      );
      if (idx !== -1) {
        this.publishModelForm.canteen_id_list.splice(idx, 1);
      }
    },
    findCanteen(row) {
      const canteen_id = Number(row.canteen_id);
      let res = this.$_.find(
        this.allCanteenList,
        a => a.canteen_id === canteen_id
      );
      const noCanteen = "无记录";
      if (res) {
        return res.eatery_name + ", " + res.canteen_name;
      } else {
        return "无记录";
      }
    },

    emitPublishDialog(row) {
      // return this.$message.error('开发中...');
      this.publishModelForm.model_uuid = row.model_uuid;
      this.$confirm("请选择此模型发布的范围", "提示", {
        confirmButtonText: "全部餐厅",
        cancelButtonText: "部分餐厅",
        distinguishCancelAndClose: true
      })
        .then(() => {
          this.publishModelForm.canteen_id_list = null;
          this.publishModel();
        })
        .catch(e => {
          if (e === "cancel") {
            this.publishDialogShow = true;
          } else {
            this.cancelPublishModel();
          }
        });
    },
    cancelPublishModel() {
      this.publishDialogShow = false;
      this.publishModelForm = {
        model_uuid: "",
        canteen_id_list: [], // -1: '全部', []: 餐厅idlist
        search: ""
      };
    },
    async publishModel() {
      let { model_uuid, canteen_id_list } = this.publishModelForm;
      try {
        await apiRegionModelPublish(model_uuid, canteen_id_list);
        this.$message.success("发布成功");
        this.cancelPublishModel();
      } catch (e) {
        this.$message.error("发布失败, " + e.message);
        this.cancelPublishModel();
      }
    },
    handleSelectionChange(rows) {
      this.label_task_ids = rows.map(a => a.label_task_id);
    },
    selectCheckable(row) {
      return row.is_check && row.is_mark;
    },
    async cancelCheck(row) {
      const { label_task_id } = row;
      try {
        await apiRegionLabelCancelCheck(label_task_id);
        // this.$message.warning()
        this.getAllRegionLabelTask();
      } catch (e) {
        this.$message.error("取消失败, " + e.message);
      }
    },
    async viewDetail(row) {
      let label_task_id = row.label_task_id;
      try {
        const res = await apiGetDetailByLabelTaskId(
          label_task_id,
          this.username
        );
        this.setPremarkData({ data: res, label_task_id: row.label_task_id });
        this.activeName = "regionFix";
      } catch (e) {
        if (e.message === "-2") {
          this.$message.error("任务正在进行中, 请等待...");
        } else {
          this.$message.error("查询详细信息失败" + e.message);
        }
      }
    },
    handleClick(tab) {
      console.log(tab);
      // this.activeName = tab;
    },
    async setStandard(row) {
      try {
        await apiSetStandard(row.model_uuid);
        this.$message.warning("设置成功");
        this.getAllRegionModel();
      } catch (e) {
        this.$message.error("错误: " + e.message);
      }
    },
    setActiveTab(tab) {
      this.activeName = tab;
    },
    async premrk(row) {
      if (!row.label_task_id) {
        return this.$message.error("此批次缺少批次id");
      }
      this.regionCheckForm.label_task_id = row.label_task_id;
      try {
        const res = await apiRegionImageRandomGetByTaskId(row.label_task_id);
        console.log(res);
        this.detectedReionDialog = true;
        this.detected_image = {
          url: res.dish_img_url
        };
      } catch (e) {
        console.log(e);
        this.$message.error("获取图片失败" + e.message);
      }
    },
    async onDetectedRegion(detectedRegion) {
      console.log(detectedRegion);
      this.regionCheckForm.detected_region = detectedRegion;
      if (this.activeName === "bigImageAdmin") {
        this.regionCheckForm.region_model_id = this.preMarkRegionModel;
        try {
          // await apiRegionModelChheckByLabelTask(this.regionCheckForm);
          const res = await apiRegionModelPreMark({
            label_task_id: this.regionCheckForm.label_task_id,
            model_uuid: this.standardRegionModel.model_uuid,
            detect_regions: this.regionCheckForm.detected_region
          });
          this.$message.error("正在预标注, 请稍后");
          this.detectedReionDialog = false;
          this.bigImageBatchShow = false;
          this.activeName = "taskList";
        } catch (e) {
          this.$message.error("标注出错" + e.message);
          console.log(e);
        }
      } else {
        try {
          const res = await apiRegionCheck({
            label_task_id: this.regionCheckForm.label_task_id,
            model_uuid: this.regionCheckForm.region_model_id,
            detect_regions: this.regionCheckForm.detected_region
          });
          this.activeName = "taskList";
          this.detectedReionDialog = false;
          this.$message.warning = "正在检测请稍后, 请稍后在任务中查看结果";
        } catch (e) {
          this.$message.error("检测出错: " + e.message);
          console.log(e);
        }
      }
      // this.$message.warning('开始检测');
    },
    async regionModelCheck(row) {
      this.bigImageBatchShow = true;
      // this.activeName = 'bigImageAdmin';
      console.log(row);
      this.regionCheckForm.region_model_id = row.model_uuid;
      // await
      // this.$notify.warning('请选择需要检测的图片批次');
    },
    async selectToCheck(row) {
      // console.log(row);
      console.log(row);
      this.regionCheckForm.label_task_id = row.label_task_id;
      const res = await apiRegionImageRandomGetByTaskId(row.label_task_id);
      this.selectCheckRow = row.label_task_id;
      console.log(res);
      this.detectedReionDialog = true;
      this.detected_image = {
        url: res.dish_img_url
      };
      // console.log(res);
    },
    async getAllRegionLabelTask() {
      try {
        let res = await apiGetAllRegionLabelTask();
        console.log(res);
        this.label_task_list = res.data;
      } catch (e) {
        console.log(e);
        this.$message.error("列表获取失败" + e.message);
      }
    },
    async beforeUpload(file) {
      this.modelForm.model_md5 = await this.computedMd5(file);
    },
    computedMd5(file) {
      let that = this;
      return new Promise((resolve, reject) => {
        let fileReader = new FileReader();
        fileReader.readAsArrayBuffer(file);
        fileReader.onload = e => {
          let md5key = md5(e.target.result);
          resolve(md5key);
        };
      });
    },
    cancelUpload() {
      this.modelForm = {
        model_name: "",
        model_desc: "",
        model_md5: "",
        model_url: "",
        manual_upload: true
      };
      this.uploadDialogShow = false;
      this.$refs["modelUpload"].clearFiles();
      this.$refs["uploadForm"].resetFields();
    },
    async confirmUpload() {
      this.$refs["uploadForm"].validate(async valid => {
        console.log(valid);
        if (!valid) {
          this.$message.error("请检查模型信息");
          return false;
        } else {
          try {
            await apiUploadRegionModel(this.modelForm);
            this.$message.warning("上传成功");
            this.cancelUpload();
            this.getAllRegionModel();
          } catch (e) {
            console.log(e);
            this.$message.error("上传失败" + e.message);
          }
        }
      });
    },
    async getAllRegionModel() {
      try {
        let res = await apiGetAllRegionModels();
        this.region_models_list = res.data;
        const res1 = this.$_.find(
          this.region_models_list,
          a => a.is_standard === true
        );
        console.log(res1);
        this.setStandardRegionModel(res1);
        console.log(res);
      } catch (e) {
        console.log(e);
        this.$message.error("模型列表获取失败" + e.message);
      }
    },
    async modelUpload(options) {
      let file = options.file;
      let storeAs = new Date().getTime();
      console.log(file);
      try {
        const { url } = await aliOSSUpload(
          {
            // prefix: 'regionModels',
            bucket: "region-model",
            name: "regionModels-" + storeAs
          },
          file
        );
        this.modelForm.model_url = url;
      } catch (e) {
        console.log(e);
        this.$message.error("模型上传到阿里云出错!" + e.message);
      }
    }
  },
  watch: {
    activeName(val, oldVal) {
      if (val === "taskList" || val === "modelAdmin") {
        this.$refs["regionTask"].getAllTaskList();
      }
      if (val === "bigImageAdmin") {
        this.getAllRegionLabelTask();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  .image-wrapper {
    position: relative;
  }
}
</style>
